import { ApiCatch, Catch } from "@/utils/decorators";
import { Invoice, InvoicesDto } from "~/invoices.type";
import { Api } from "../api.service";

export class InvoicesService {
  @Catch(() => [])
  static async getInvoices(payload: InvoicesDto): Promise<Invoice[]> {
    const response = await Api.get("/invoices/", {
      params: { ...payload },
    });
    return response.data;
  }

  @ApiCatch
  static async getInvoiceDetails(invoiceRid: string) {
    const response = await Api.get("/invoices/" + invoiceRid);
    return response.data;
  }

  @ApiCatch
  static async getInvoiceStatuses() {
    const response = await Api.get("/invoices/statuses");
    return response.data;
  }
}
